import { Component, inject } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { AddMessageReplyData, createReplyFormGroup, CreateReplySingleResponse, StoreCreateReplyRequest } from '@lib/api/models/message';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { MessageService } from '@lib/messages/message.service';

@Component({
    selector: 'app-add-message-reply-dialog',
    imports: [
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule
    ],
    templateUrl: './add-message-reply-dialog.component.html',
    standalone: true,
    styleUrl: './add-message-reply-dialog.component.scss'
})
export class AddMessageReplyDialogComponent {

    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    protected readonly data = inject<AddMessageReplyData>(DIALOG_DATA);
    protected readonly replyFormGroup = createReplyFormGroup()
    private readonly _messageService = inject(MessageService)
    private readonly _snackBar = inject(SnackBarService);

    addReplyRequest = new SendableRequest<CreateReplySingleResponse, StoreCreateReplyRequest>({
        request: (payload) => this._messageService.createReply(payload!),

        onSend: () => {
          this.replyFormGroup.disable();
        },

        onSuccess: () => {
          this.replyFormGroup.enable();
          this._snackBar.open({
            colour: 'success',
            icon: 'check',
            title: 'Reply Sent'
          });
          this.dialogRef.close();
        },

        onError: () => {
          this.replyFormGroup.enable();
        }
      });

    addReply() {
        if (this.addReplyRequest.loading()) {
          return;
        }

        const addReplyData: StoreCreateReplyRequest = {
          thread_id: this.data.threadId,
          content: this.replyFormGroup.controls.content.value || ''
        };

        this.addReplyRequest.send(addReplyData);
      }

    public static show(dialog: DialogService, data: AddMessageReplyData) {
        return dialog.openDialog<DialogRef, AddMessageReplyData>(AddMessageReplyDialogComponent, {
            data
        });
    }
}
